import React, {Component} from "react";
import {
    Panel,
    Modal,
    Button
}                         from "react-bootstrap";
import axios              from "axios";
import {
    ToastContainer,
    toast
}                         from "react-toastify";
import                         "react-toastify/dist/ReactToastify.css";

import {
    IS_UNDEFINED,
    IS_EMPTY_STRING,
    IS_VALID
}                         from "utils";

import CrudComponent      from "../zynappse-crud";
import
TierBlockMessageSchema    from "./TierBlockMessageSchema";
import saveTrail          from "utils/saveTrail";
import FormContainer      from "./FormContainer";

const WEB_PATH = window.__APP_CONFIG__.webPath || 'http://localhost:3000';

class TierBlockMessage extends Component {
    constructor (props) {
        super(props);

        this.refreshTableReference;

        this.refreshTable = this.refreshTable.bind(this);
        this.saveData = this.saveData.bind(this);
        this.getTierBlockMessageConfig = this.getTierBlockMessageConfig.bind(this);
        this.saveTierBlockMessageConfig = this.saveTierBlockMessageConfig.bind(this);
        this.renderModalButton = this.renderModalButton.bind(this);
        this.accessible = this.accessible.bind(this);
    }

    refreshTable () {
        if (
            IS_VALID(IS_VALID) &&
            typeof this.refreshTableReference === "function"
        ) {
            this.refreshTableReference();
        }
    }

    async saveData () {
        let {
            TierBlockMessage,
            actions
        } = this.props;

        let {
            selectedData,
            formType,
            formId,

            title,
            browser,
            url,
            content
        } = TierBlockMessage;

        let sanitizeContent = content; // sanitizeHtml(content, {allowedTags: [],allowedAttributes: []});

        if (
            !IS_VALID(title) ||
            !IS_VALID(title.trim())
        ) {
            toast.error("Title is required.");
        } else if (
            IS_VALID(browser) &&
            (
                !IS_VALID(url) ||
                !IS_VALID(url.trim())
            )
        ) {
            toast.error("URL is required.");
        } else  if (!IS_VALID(sanitizeContent.trim())) {
            toast.error("Content is required.");
        } else {
            actions.setValue({
                isLoadingAction: true
            });

            let fd = new FormData();

            fd.append("userId", Parse.User.current().id);
            fd.append("title", title);
            fd.append("content", content);

            if (IS_VALID(browser)) {
                fd.append("browser", browser.value);

                fd.append("url", url);
            }

            let httpMethod = "post",
                apiUrl = `${WEB_PATH}/TierBlockMessage`;

            if (
                (
                    !IS_EMPTY_STRING(formType) &&
                    formType.toUpperCase() === "UPDATE"
                ) &&
                !IS_EMPTY_STRING(formId)
            ) {
                httpMethod = "put";
                apiUrl = `${apiUrl}/${formId}`;
            }

            axios[httpMethod](apiUrl, fd)
            .then((res) => {
                let {
                    data,
                    changesObject
                } = res.data;

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();

                saveTrail(
                    formType.toUpperCase(),
                    changesObject
                );
            })
            .catch((err) => {
                console.log("saveData error");
                console.log(err);

                actions.setValue({
                    isLoadingAction: false,
                    showModal: false
                });

                this.refreshTable();
            });
        }
    }

    getTierBlockMessageConfig () {
        let {
            actions
        } = this.props;

        actions.setValue({
            isLoadingConfig: true
        });

        let customBlockMessageConfigQuery = new Parse.Query("CustomBlockMessageConfig");

        customBlockMessageConfigQuery
        .equalTo("name", "TIER")
        .descending("createdAt");

        customBlockMessageConfigQuery.first()
        .then((data) => {
            let stateToUpdate = {
                isLoadingConfig: false
            };

            if (IS_VALID(data)) {
                stateToUpdate.isActive = IS_VALID(data.get("isActive")) ? data.get("isActive") : true;
                stateToUpdate.customBlockMessageConfig = data;
            } else {
                stateToUpdate.isActive = true;
            }

            actions.setValue(stateToUpdate);
        })
        .catch((err) => {
            console.log("getTierBlockMessageConfig error");
            console.log(err);

            actions.setValue({
                isLoadingConfig: false
            });
        });
    }

    saveTierBlockMessageConfig () {
        let {
            TierBlockMessage,
            actions
        } = this.props;
        
        let {
            isActive,
            customBlockMessageConfig
        } = TierBlockMessage

        actions.setValue({ isSavingConfig: true });

        new Promise((resolve, reject) => {
            if (IS_VALID(customBlockMessageConfig)) {
              resolve(customBlockMessageConfig);
            } else {
              let query = new Parse.Query("CustomBlockMessageConfig");
      
              query
              .equalTo("name", "TIER")
              .descending("createdAt");
              
              query.first()
              .then(resolve)
              .catch(reject);
            }
        })
        .then((customBlockMessageConfig) => {
            if (IS_UNDEFINED(customBlockMessageConfig)) {
                customBlockMessageConfig = new Parse.Object("CustomBlockMessageConfig");

                customBlockMessageConfig.set("name", "TIER");
            }

            customBlockMessageConfig
            .set("isActive", !isActive);

            return customBlockMessageConfig.save();
        })
        .then((customBlockMessageConfig) => {
            let stateToUpdate = {
                isSavingConfig: false,
                isActive: !isActive,
                showModalConfig: false,
                customBlockMessageConfig
            };
        
            actions.setValue(stateToUpdate);

            saveTrail(
                isActive ? "DEACTIVATE" : "ACTIVATE",
                {
                    isActive: !isActive
                }
            );
        })
        .catch((err) => {
            console.log("saveTierBlockMessageConfig error");
            console.log(err);

            actions.setValue({
                isSaving: false,
                showModalConfig: false
            });
        });
    }

    renderModalButton () {
        let {
            TierBlockMessage,
            actions
        } = this.props;
        
        let {
            isLoadingAction,
            formType
        } = TierBlockMessage;

        let buttons = [],
            buttonAction = (
                name = "CREATE",
                loading = isLoadingAction,
                callback = this.saveData
            ) => (
                <Button
                    bsStyle="primary"
                    disabled={loading}
                    onClick={() => callback()}
                >
                    {name}
                </Button>
            ),
            buttonClose = (
                <Button
                    disabled={isLoadingAction}
                    onClick={() => {
                        if (!isLoadingAction) {
                            actions.setValue({
                                showModal: false
                            });
                        }
                    }}
                >
                    CLOSE
                </Button>
            );

        switch (formType.toUpperCase()) {
            case "CREATE":
                buttons.push(
                    buttonAction(
                        "CREATE",
                        isLoadingAction
                    ),
                    buttonClose
                );
                break;
            case "UPDATE":
                buttons.push(
                    buttonAction(
                        "UPDATE",
                        isLoadingAction
                    ),
                    buttonClose
                );
                break;
            default:
                buttons.push(
                    buttonClose
                );
                break;
        }
        return buttons;
    }

    accessible (actionType) {
        let {
            access
          } = this.props.accessjson;
      
          if (access.length !== 0) {
            var currentPath = window.location.pathname,
                    index = access.map((module) => module.route.toUpperCase()).indexOf(currentPath.toUpperCase()),
                    actions = [];

            if (access[index]) {
                actions = access[index].actions
            }

            if (actions.length != 0) {
                if (actions.indexOf(actionType.toUpperCase()) === -1) {
                    return 'none';
                } else {
                    return '';
                }
            } else {
                return 'none';
            }
        } else {
            return 'none';
        }
    }

    render () {
        let {
            TierBlockMessage,
            accessjson,
            actions
        } = this.props;

        let {
            showModal,
            isLoadingAction,
            selectedData,
            formType,
            formTitle,

            browserOptions,

            showModalConfig,
            isSavingConfig,
            isLoadingConfig,
            isActive
          } = TierBlockMessage;

        let crudProps = {
            schema: TierBlockMessageSchema,
            access: accessjson.access,
            moduleQuery: [
                { method: "descending", column: "createdAt" }
            ],
            saveTrail: saveTrail,
            customView: (obj) => {
                actions.setValue({
                    showModal: true,
                    formType: "VIEW",
                    formTitle: "VIEW TIER BLOCK MESSAGE",
                    formId: obj.id,
                    selectedData: obj
                });
            },
            customCreate: () => {

            },
            customUpdate: (obj) => {
                let stateToUpdate = {
                    showModal: true,
                    formType: "UPDATE",
                    formTitle: "UPDATE TIER BLOCK MESSAGE",
                    formId: obj.id,
                    selectedData: obj
                };

                if (IS_VALID(obj.get("title"))) {
                    stateToUpdate.title = obj.get("title");
                }

                if (IS_VALID(obj.get("browser"))) {
                    let index = browserOptions.map(({ value }) => value).indexOf(obj.get("browser"));

                    if (index !== -1) {
                        stateToUpdate.browser = browserOptions[index];
                    }
                }

                if (IS_VALID(obj.get("url"))) {
                    stateToUpdate.url = obj.get("url");
                }

                if (IS_VALID(obj.get("content"))) {
                    stateToUpdate.content = obj.get("content");
                }

                actions.setValue(stateToUpdate);
            },
            customDelete: (obj) =>{

            },
            refreshTable: (refreshTable) => {
                this.refreshTableReference = refreshTable;
            },
            customItems: [
                {
                    columnName: "title",
                    render: ({value, column, getTableData, object}) => {
                        let renderValue = "";
            
                        if (IS_VALID(value)) {
                            renderValue = value.substr(0, 100).trim() + (value.length <= 100 ? "" : "...");
                        }
            
                        return renderValue;
                    }
                },
                {
                    columnName: "content",
                    render: ({value, column, getTableData, object}) => {
                        let renderValue = object.get("content") || "";

                        // let sanitizeContent = sanitizeHtml(value || "", { allowedTags: [], allowedAttributes: [] });

                        renderValue = renderValue.substr(0, 100).trim() + (renderValue.length <= 100 ? "" : "...");
                        
                        return renderValue;
                    }
                }
            ]
        };

        let formContainerProps = {
            actions,

            selectedData,
            formType
        };

        let isActivateAccessible = this.accessible("ACTIVATE") === "",
            isDeactivateAccessible = this.accessible("DEACTIVATE") === "";
        
        return (
            <div>
                <Panel>
                    <Panel.Heading
                        style={{
                            backgroundColor: '#D1282F',
                            color: 'white'
                        }}
                    >
                        <h4 style={{ display: "inline-block" }}>Tier Block Message</h4>
                        <div style={{ float: "right" }}>
                            <Button
                                style={(isActive ? !isDeactivateAccessible : !isActivateAccessible) ? { cursor: "not-allowed" } : null}
                                bsStyle={isLoadingConfig ? null : isActive ? "success" : "danger"}
                                disabled={isLoadingConfig || (isActive ? !isDeactivateAccessible : !isActivateAccessible)}
                                onClick={() => {

                                    if (
                                        (isActive ? !isDeactivateAccessible : !isActivateAccessible)
                                    ) {
                                        return;
                                    }

                                    actions.setValue({
                                        showModalConfig: true
                                    });
                                }}
                            >
                                {isLoadingConfig ? (
                                    <i className="fa fa-spinner fa-spin"/>
                                ) : (
                                    isActive ? "ACTIVE" : "INACTIVE"
                                )}
                            </Button>
                        </div>
                    </Panel.Heading>
                    <Panel.Body>
                        <CrudComponent {...crudProps}/>
                    </Panel.Body>
                </Panel>
                <Modal
                    show={showModal}
                    onHide={() => {
                        if (!isLoadingAction) {
                            actions.setValue({
                                showModal: false
                            })
                        }
                    }}
                    bsSize={null}
                >
                    <Modal.Header closeButton>
                        <Modal.Title>{formTitle.toUpperCase()}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <FormContainer {...formContainerProps}/>
                    </Modal.Body>
                    <Modal.Footer>
                        {this.renderModalButton()}
                    </Modal.Footer>
                </Modal>
                <Modal
                    show={showModalConfig}
                    onHide={() => {
                        if (!isSavingConfig) {
                            actions.setValue({
                                showModalConfig: false
                            });
                        }
                    }}
                    bsSize="small"
                >
                    <Modal.Header closeButton>
                        <h4>{isActive ? "DEACTIVATE " : "ACTIVATE "} TIER BLOCK MESSAGE</h4>
                    </Modal.Header>
                    <Modal.Body>
                        {`Are you sure you want to ${isActive ? "deactivate" : "activate"} Tier Block Message?`}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            bsStyle={isActive ? "danger" : "success"}
                            disabled={isSavingConfig}
                            onClick={() => this.saveTierBlockMessageConfig()}
                        >
                            {isActive ? "DEACTIVATE" : "ACTIVATE"}
                        </Button>
                    </Modal.Footer>
                </Modal>
                <ToastContainer />
            </div>
        );
    }

    componentDidMount () {
        this.getTierBlockMessageConfig();
    }
}

import {connect}            from "react-redux";
import {bindActionCreators} from "redux";
import {generics}           from "actions";
import {
    TIER_BLOCK_MESSAGE
}                           from "actions/const";

function mapStateToProps(state) {
	let {
        TierBlockMessage,
        accessjson
	} = state;

	return {
        TierBlockMessage,
        accessjson
	};
}


function mapDispatchToProps(dispatch) {
    const actions = {
        setValue: (stateObject, actionType = TIER_BLOCK_MESSAGE) => generics.setValue(actionType, stateObject)
    };
  
    return {
        actions: bindActionCreators(actions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(TierBlockMessage);


// WEBPACK FOOTER //
// ./components/TierBlockMessage/index.js